import React, { useEffect, useState } from 'react';
import './App.scss';
import {
  BrowserRouter,
  Route,
} from 'react-router-dom';
import { FileContext } from 'context/FileContext';
import RouterTransition from './page/RouterTransition';

function App(): JSX.Element {
  const [ uploadedFiles, setFiles ] = useState<{ files: File[]; }>({ files: [] });

  const onChangeFile = (event: React.FormEvent<HTMLInputElement>) => {
    if (event.target) {
      const fileList = (event.target as HTMLInputElement).files;
      if (fileList) {
        setFiles({
          files: [ ...uploadedFiles.files, ...Array.from(fileList as ArrayLike<File>) ],
        });
      }
    }
  };

  const deleteFile = (file: File) => {
    setFiles({
      files: uploadedFiles.files.filter((item) => item !== file),
    });
  };

  useEffect(() => {
    const handleEvent = (event: Event) => event.preventDefault();
    window.addEventListener('contextmenu', handleEvent);

    return () => window.removeEventListener('contextmenu', handleEvent);
  });

  const initialFileContext = {
    ...uploadedFiles,
    onChangeFile,
    deleteFile,
    urls: uploadedFiles.files.map((file) => URL.createObjectURL(file)),
  };

  return (
    <FileContext.Provider value={initialFileContext}>
      <main>
        <BrowserRouter>
          <Route>
            <RouterTransition />
          </Route>
        </BrowserRouter>
      </main>
    </FileContext.Provider>
  );
}

export default App;
